module.exports = __webpack_public_path__ + "fonts/Inter-600-greek42.3a3cf1a.woff2";